// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ra2S","colBig":"styles_colBig__1DsrE","colSmall":"styles_colSmall__2ekF6"};